import React from 'react';
import { useInView } from '../hooks/useInView';

const categories = [
  {
    label: 'Languages',
    items: ['JavaScript', 'TypeScript', 'Java', 'C#', 'C++', 'HTML', 'CSS'],
    color: '#1a1a18',
  },
  {
    label: 'Frameworks & Tech',
    items: ['Node.js', 'NestJS', 'React', 'Next.js', 'Angular', 'GraphQL', 'Spring Boot'],
    color: '#c8602a',
  },
  {
    label: 'Infrastructure',
    items: ['Kafka', 'Redis', 'BullJS', 'Docker', 'Jenkins', 'CDC Connectors'],
    color: '#2a6680',
  },
  {
    label: 'Observability',
    items: ['New Relic', 'Grafana (Loki)', 'OpenAI APIs'],
    color: '#5a4a8a',
  },
  {
    label: 'Databases',
    items: ['MongoDB', 'PostgreSQL', 'MSSQL', 'SQL'],
    color: '#3a6b3a',
  },
];

export default function Skills() {
  const [ref, inView] = useInView(0.1);

  return (
    <section id="skills" ref={ref} style={{
      padding: 'clamp(80px, 10vw, 140px) clamp(24px, 8vw, 120px)',
      background: 'var(--white)',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(24px)', transition: 'all 0.6s ease', marginBottom: 60 }}>
          <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--accent-warm)', marginBottom: 20 }}>
            04 — Skills
          </p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 4vw, 52px)', lineHeight: 1.1, letterSpacing: '-0.02em' }}>
            Tech I work with.
          </h2>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {categories.map((cat, ci) => (
            <div key={cat.label}
              style={{
                display: 'grid', gridTemplateColumns: 'clamp(120px, 18%, 200px) 1fr',
                borderBottom: '1px solid var(--border)', padding: '36px 0', gap: 40,
                alignItems: 'center',
                opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(16px)',
                transition: `all 0.6s ease ${ci * 0.1 + 0.2}s`,
              }}>
              <div>
                <div style={{ width: 28, height: 3, background: cat.color, marginBottom: 12, borderRadius: 1 }} />
                <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-3)' }}>
                  {cat.label}
                </p>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {cat.items.map((item, ii) => (
                  <span key={item}
                    style={{
                      fontFamily: 'var(--font-mono)', fontSize: 12, letterSpacing: '0.04em',
                      color: 'var(--ink)', padding: '8px 16px',
                      border: '1px solid var(--border)', borderRadius: 2,
                      background: 'var(--cream)', cursor: 'default',
                      transition: 'all 0.2s',
                    }}
                    onMouseEnter={e => {
                      e.target.style.borderColor = cat.color;
                      e.target.style.color = cat.color;
                      e.target.style.background = 'var(--white)';
                    }}
                    onMouseLeave={e => {
                      e.target.style.borderColor = 'var(--border)';
                      e.target.style.color = 'var(--ink)';
                      e.target.style.background = 'var(--cream)';
                    }}
                  >{item}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 520px) {
          #skills > div > div > div {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
          }
        }
      `}</style>
    </section>
  );
}
